var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"top-0 bottom-0 position-absolute w-100 h-100 left-0 right-0 h-100 border-0",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100%","min-height":"600px"},attrs:{"src":_vm.content.content,"allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }